// Import Vue first
import Vue from 'vue';

// Admin Components
import SegmentClassificationsManager from './components/SegmentClassificationsManager.vue';
import ClassificationTreeItem from './components/ClassificationTreeItem.vue';

// Register components globally
Vue.component('segment-classifications-manager', SegmentClassificationsManager);
Vue.component('classification-tree-item', ClassificationTreeItem);

// Export for use in other contexts
window.SegmentClassificationsManager = SegmentClassificationsManager;
window.ClassificationTreeItem = ClassificationTreeItem;
